import type { ColumnType } from 'antd/es/table';

import { sortByAmount, sortByTime } from 'utils/antd/sorters';
import { formatDecimalAmount } from 'utils/formatters/formatCurrency';

import type { CollectionPaymentStatus } from 'api';

import { PaymentBadge } from '@atoms/badges';
import { ColumnTitle } from '@atoms/ColumnTitle';
import { TransactionIconPlus } from '@atoms/Icon';

import { FormattedDateTime } from '@molecules/FormattedDateTime';

import type { PaymentRow } from './types';

export const getColumns = (): ColumnType<PaymentRow>[] => {
  return [
    {
      dataIndex: 'icon',
      key: 'icon',
      width: 100,
      render: () => (
        <div className="flex justify-center">
          <TransactionIconPlus className="size-8" />
        </div>
      )
    },
    {
      title: <ColumnTitle title="Date" />,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (createdAt: string) => <FormattedDateTime value={createdAt} />,
      sorter: (a, b) => sortByTime(a.created_at, b.created_at),
      onHeaderCell: () => ({
        className: 'align-sorter-icon'
      })
    },
    {
      title: <ColumnTitle title="ID/Reference" />,
      dataIndex: 'unique_reference',
      key: 'unique_reference',
      width: 200,
      render: (uniqueReference: string) => (
        <div>
          <p className="text-sm">{uniqueReference.toLocaleUpperCase()}</p>
          <div className="font-semibold" data-testid="payment_unique_reference">
            {uniqueReference.toLocaleUpperCase()}
          </div>
        </div>
      ),
      onHeaderCell: () => ({
        className: 'align-sorter-icon'
      })
    },
    {
      title: <ColumnTitle title="Amount" />,
      dataIndex: 'order.amount',
      key: 'order.amount',
      align: 'right',
      sorter: (a, b) => sortByAmount(a.amount, b.amount),
      render: (_: string, record: PaymentRow) => {
        const formattedAmount = formatDecimalAmount(
          Number.parseFloat(record.order.amount)
        );
        return (
          <div>
            <p className="text-sm">{record.order.currency}</p>
            <div className="font-semibold">{formattedAmount}</div>
          </div>
        );
      }
    },
    {
      title: <ColumnTitle title="Status" />,
      dataIndex: 'status',
      key: 'status',
      align: 'right',
      render: (status: CollectionPaymentStatus) => {
        return <PaymentBadge type={status} />;
      }
    }
  ];
};
